import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const Success = forwardRef(function Success(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, props, { ref: ref, children: jsx("path", { clipRule: "evenodd", d: "M21.9144 6.50015L9.00015 19.4144L2.08594 12.5002L3.50015 11.0859L9.00015 16.5859L20.5002 5.08594L21.9144 6.50015Z", fill: "currentColor", fillRule: "evenodd" }) })));
});

export { Success as default };
//# sourceMappingURL=Success.js.map
